
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Attach AI Automation Template to {{selectedFolderName}}.
    <button mat-icon-button (click)="closeAIAutomationTemplate()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>


  <div class="template-holder">
    <div class="left">

      <mat-form-field appearance="fill">
        <mat-label>Select Category</mat-label>
        <mat-select value="My Template">
          <mat-option value="My Template">My Template</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="list" #categoryList>
        <ul>
          <li (click)="getAIAutomationCategoryForImport(0, 0)" [ngClass]="{'active': currentIndex == 0 }">All
          </li>        
        </ul>

      </div>

    </div>
    <div class="right">

      <div class="list">

        <div class="tempalteList">
          <table cellspacing="0" cellspadding="0" width="100%">
            <tr>
              <th>Automation Template</th>
              <th>Field Template</th>
              <th>Question Template</th>
              <th class="actBtn">Action</th>
            </tr>
            <tr *ngFor="let template of aITemplateList"
              [ngClass]="{ 'active': template.aiAutomationTemplateID === aiAutomationTemplateID}"
              [ngStyle]="{ 'background-color': template.aiAutomationTemplateID === aiAutomationTemplateID ? '#e8f0fe' : 'transparent' }">

              <td class="formName">
                {{template.name}}
              </td>

              <td class="formName">
                {{template.fieldTemplateName}}
              </td>
              <td class="formName">
                {{template.promptTemplateName}}
              </td>
              <td>
                <button mat-stroked-button color="primary" (click)="SelectAITemplate(template)">Select</button>
              </td>
            </tr>
          </table>
          <div *ngIf="ShowNoRecordFoundAITemplates" class="noRecordFound">No Record Found</div>
        </div>

      </div>

    </div>
  </div>

  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeAIAutomationTemplate()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary" *ngIf="aiAutomationTemplateID!=0"
    (click)="attachAIAutomationTemplate()">
      Attach
    </button>
  </mat-dialog-actions>


